import { CurrencyPipe, TitleCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ClientSideRowModelModule, ColDef, ExcelCell, ExcelExportParams, ExcelStyle, GridApi, GridOptions, GridReadyEvent, Module, RowHeightParams, ValidationModule } from 'ag-grid-community';
import { AllEnterpriseModule } from 'ag-grid-enterprise';
import { DateTime } from 'luxon';
import { AccountInfo, Classifications } from 'projects/money-movement-ui/src/app/account-info-header/models';
import { selectClassifications, selectInfo, selectIsPendingItSloaSetup, selectItStandingAuth, selectNraIndicator, selectStateCode, selectSubAccountId } from 'projects/money-movement-ui/src/app/account-info-header/reducers';
import { gridReady } from 'projects/money-movement-ui/src/app/create-request/actions/transactions-table-actions';
import { amountColumnTemplate } from 'projects/money-movement-ui/src/app/create-request/components/transactions-table/table-helpers';
import { Constants, PageNameTypes, YesNo, amountTypeDict, frequencyDict, pageInContext, pdfLabelsSubmitDetails, positionConstants, transactionDetailLabels, transactionTypes, transactionTypesDict, transferTypes, yesNo } from 'projects/money-movement-ui/src/app/shared/utilities/Constants';
import { selectIsStandingAuthViewPage, selectIsTransactionsViewPage } from 'projects/money-movement-ui/src/app/transaction-view/reducers';
import { Observable, Subject, combineLatest } from 'rxjs';
import { map, takeUntil, withLatestFrom } from 'rxjs/operators';
import { ReviewPageActions } from '../../../../create-request/actions';
import { ItExtraPrompts, isInternalTransferForm } from '../../../../create-request/models/form/TransactionForm';
import { InternalTransferInfo } from '../../../../create-request/models/internal-transfer/InternalTransferInfo';
import { ToAccountInfo } from '../../../../create-request/models/internal-transfer/ToAccountInfo';
import { selectCostBasisMethod, selectInternalTransferInfo, selectIraFieldsIsIraTransaction, selectItStwProcessCode, selectPositionLotTableData, selectStagedTransactionForm, selectToAccountInfo, selectTransferType } from '../../../../create-request/reducers';
import { FormatPercentPipe } from '../../../pipes/FormatPercentPipe';
import { selectViewInContext } from '../../../reducers';
import { agFilterNames } from '../../../types/AgFilterNames';
import { StandingInstruction } from '../../../types/StandingInstruction';
import { AmountType } from '../../../types/Transaction';

@Component({
  standalone: false,
  selector: 'mm-transaction-details-section-it',
  templateUrl: './transaction-details-section-it.component.html',
  styleUrls: ['./transaction-details-section-it.component.scss']
})
export class TransactionDetailsSectionItComponent implements OnInit {
  @Input() isInrFromTable: boolean;
  readonly labels = transactionDetailLabels;
  readonly pdfLabelsSubmitDetails = pdfLabelsSubmitDetails;
  readonly nextBusinessDayCopy: string = Constants.nextBusinessDayCopy;
  readonly taxCopyParagraphOne: string = Constants.taxCopyParagraphOne;
  readonly taxCopyParagraphTwo: string = Constants.taxCopyParagraphTwo;
  createRequestStep$: Observable<string>;
  useStandingAuth: YesNo | '';
  isBundledStandingAuthTransaction: boolean;
  frequency: string;
  standingAuth: StandingInstruction;
  standingAuthDetails: string[] = [];
  frequencyDescription: string;
  instructionId: string;
  secondProcessDate: string;
  endDate: string;
  payIncome: string;
  toAccountInfo: ToAccountInfo;
  accountInfo: AccountInfo;
  isSameFirm: boolean;
  transactionTypeLabel: string;
  amount: string;
  amountType: AmountType;
  fedTaxPercent: string;
  stateTaxPercent: string;
  fedTaxAmount: string;
  stateTaxAmount: string;
  itInfo: InternalTransferInfo;
  destroy$: Subject<boolean> = new Subject<boolean>();
  classifications: Classifications = new Classifications();
  nraIndicator: boolean;
  stwProcessCode: string;
  trustIncomePercent: string;
  trustPrincipalPercent: string;
  trustTaxCode: string;
  trustPaidFor: string;
  trustComment: string;
  trustTaxCategory: string;
  trustIncomeToPercent: string;
  trustPrincipalToPercent: string;
  depositTaxCode: string;
  isToAccountTrust: boolean;
  costBasis: any | string = "";
  transferType: string;
  formTransferType: string;
  isStandingAuthViewPage: boolean = false;
  isTransactionViewPage: boolean;
  isIraTransaction: boolean;
  isRecurring: boolean;
  nextProcessDate: string;
  viewPagePtrsInfoBannerPrimaryText = Constants.viewPagePtrsInfoBannerPrimaryText;
  positionsTaxImplicationDisclaimer = Constants.positionsTaxImplicationDisclaimer;
  viewPagePtrsInfoBannerBoldText = Constants.viewPagePtrsInfoBannerBoldText;
  costBasisDefault: string | any = "";
  isPendingSloaSetup: boolean;
  showCostBasis: boolean = false;
  isPositionsOnly: boolean = false;
  positionsViewPageBannerMessage: string = positionConstants.PositionsViewPageBannerMessage;
  taxLotOptimizerWarningMessage = positionConstants.taxLotOptimizerWarningMessage;
  hasPositions: boolean = false;
  gridApi: GridApi | undefined | null;
  gridOptions: GridOptions;
  displaytotalShared: any = 0;
  currentPage: PageNameTypes;
  reviewConfirmationPage: boolean = false;
  displaySelectedValue: string | null;
  displayPositionsSection: boolean = true;
  defaultExportParams: ExcelExportParams;
  totalSharesCount: number = 0;
  excelStyles: ExcelStyle[] = [];
  gridColumnApi: GridApi | undefined | null;
  subAccountId: string;
  rowData$: Observable<any[]>;
  showToAccountAvailableCash: boolean;
  showIRAContributionType: boolean;
  iraContributionType: string;
  globalModules: Module[] = [
    ValidationModule,
    AllEnterpriseModule,
    ClientSideRowModelModule
  ]
  defaultColumnDefs: ColDef = {
    filter: agFilterNames.text,
    sortingOrder: ['asc', 'desc'],
    suppressHeaderMenuButton: true,
    suppressHeaderContextMenu: true,
    suppressHeaderFilterButton: true,
    sortable: true,
    resizable: false,
    unSortIcon: true,
    flex: 1,
    minWidth: 29,
    cellClass: 'customCellPadding',
  };
  icons = {
    sortAscending: '<i class="sch-caret-up "/>',
    sortDescending: '<i class="sch-caret-down"/>',
    filter: '<i class="sch-search" />',
    sortUnSort: '<i class="sch-caret-down"/>'
  };
  columnDefs: ColDef[] = [
    {
      field: 'Symbol',
      floatingFilterComponent: 'customTextFloatingFilter',
      width: 85,
      lockPosition: true,
      cellClass: ['cellPadding'],
      filter: false,
      tooltipComponent: 'customTooltip',
      colId: 'symbol',
    },
    {
      field: 'Name',
      tooltipField: "Name",
      floatingFilterComponent: 'customTextFloatingFilter',
      cellStyle: { 'text-overflow': 'ellipsis', 'white-space': 'nowrap', 'overflow': 'hidden' },
      width: 85,
      lockPosition: true,
      cellClass: ['cellPadding'],
      filterParams: { showTooltips: true },
      filter: false,
      tooltipComponent: 'customTooltip',
      floatingFilterComponentParams: {
        suppressFilterButton: true
      },
      colId: 'name',
    },
    {
      field: 'Current price/share',
      resizable: false,
      type: 'rightAligned',
      comparator: this.currencyComparator,
      width: 120,
      lockPosition: true,
      filter: false,
      cellClass: 'customCellPadding',
      headerComponentParams: { template: amountColumnTemplate },
      colId: 'pricepeshare'
    },
    {
      field: 'Cost basis',
      resizable: false,
      type: 'rightAligned',
      width: 110,
      lockPosition: true,
      filter: false,
      cellClass: 'customCellPadding',
      comparator: this.currencyComparator,
      headerComponentParams: { template: amountColumnTemplate },
      colId: 'costbasis',
      hide: true,
    },
    {
      field: 'Shares to move',
      floatingFilterComponent: 'customTextFloatingFilter',
      width: 85,
      lockPosition: true,
      cellClass: ['cellPadding'],
      filter: false,
      tooltipComponent: 'customTooltip',
      colId: 'sharestomove',
    },
    {
      field: 'Est mkt val',
      headerName: 'Est mkt val.',
      resizable: false,
      width: 185,
      type: 'rightAligned',
      comparator: this.currencyComparator,
      filter: false,
      lockPosition: true,
      cellClass: 'customCellPadding',
      headerComponentParams: { template: amountColumnTemplate },
      colId: 'estmrkvalue',
    },
  ];
  stateTaxLabel: string = this.labels.stateTax;

  constructor(private store: Store, private titleCasePipe: TitleCasePipe, private currencyPipe: CurrencyPipe, private percentFormatPipe: FormatPercentPipe) {
    this.toAccountInfo = new ToAccountInfo();
    this.itInfo = new InternalTransferInfo();

    function cell(text: string, styleId?: string): ExcelCell {
      return {
        styleId: styleId,
        data: {
          type: /^\d+$/.test(text) ? 'Number' : 'String',
          value: String(text)
        }
      };
    }

    this.defaultExportParams = {
      getCustomContentBelowRow: (params: any) => {
        return [
          {
            cells: [
              cell('', 'header'),
              cell(' ', 'header'),
              cell(' ', 'header'),
              cell(' ', 'header'),
              cell(' ', 'header'),
            ]
          }
        ]
      },
      columnWidth: 165
    };

    this.excelStyles = [
      {
        id: "cell",
        font: { color: 'black', },
        alignment: { vertical: 'Center', horizontal: 'Center', wrapText: true },
        borders:
        {
          borderBottom: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderLeft: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderRight: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderTop: { color: '#000000', lineStyle: 'Continuous', weight: 1, }
        }
      },
      {
        id: "body",
        font: { color: 'black', },
        alignment: { vertical: 'Center', horizontal: 'Center' },
        borders:
        {
          borderBottom: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderLeft: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderRight: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderTop: { color: '#000000', lineStyle: 'Continuous', weight: 1, }
        }
      },
      {
        id: 'header',
        font: { bold: true },
        interior: { color: '#F1F1F1', pattern: 'Solid', patternColor: 'white' },
        alignment: { vertical: 'Center', horizontal: 'Center', },
        borders:
        {
          borderBottom: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderLeft: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderRight: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderTop: { color: '#000000', lineStyle: 'Continuous', weight: 1, }
        }
      }];
  }

  ngOnInit(): void {
    this.createRequestStep$ = this.store.select(selectViewInContext);
    this.store.select(selectInternalTransferInfo).pipe(takeUntil(this.destroy$)).subscribe(itInfo => {
      this.showIRAContributionType = itInfo.iraContributionType.description !== '' && itInfo.iraContributionType.description !== null;
      this.itInfo = itInfo;
      this.iraContributionType = this.formatContribType(this.itInfo.iraContributionType.description);
      this.fedTaxAmount = this.getTaxAmount(itInfo.iraFields.fedTaxAmount);
      this.stateTaxAmount = this.getTaxAmount(itInfo.iraFields.stateTaxAmount);
      this.isToAccountTrust = itInfo.toAccountInfo.isTrust;
    });

    this.rowData$ = this.store.select(selectInternalTransferInfo).pipe(map((cashieringTransactions) =>
    this.mapPositions(cashieringTransactions.positionsInfo.list)
  ));

  this.gridOptions = {
    columnDefs: this.columnDefs,
    defaultExcelExportParams: this.defaultExportParams,
    excelStyles: this.excelStyles,
    theme: 'legacy'
  }

  this.createRequestStep$.pipe(takeUntil(this.destroy$)).subscribe(page => {
    this.currentPage = page as PageNameTypes;
  });

    this.store.select(selectIraFieldsIsIraTransaction).pipe(takeUntil(this.destroy$)).subscribe(_isIraTransaction => this.isIraTransaction = _isIraTransaction)

    this.store.select(selectClassifications).pipe(takeUntil(this.destroy$)).subscribe(classifications => {
      this.classifications = classifications;
    });

    combineLatest([
      this.store.select(selectTransferType),
      this.store.select(selectInternalTransferInfo)
    ]).pipe(takeUntil(this.destroy$)).subscribe(([transferType, itInfo]) => {
      this.transferType = (typeof transferType === 'string') ? transferType : "";
      if (this.transferType === transferTypes.POSITIONS) {
        if (itInfo.iraFields.isIraTransaction && (Number.parseFloat(itInfo.iraFields.fedTaxPercent) !== 0 || Number.parseFloat(itInfo.iraFields.stateTaxPercent) !== 0)) {
          this.formTransferType = this.labels.positionsCash;
        }
        else {
          this.formTransferType = this.labels.positions;
        }
      }
      else if (this.transferType === transferTypes.CASH) {
        this.formTransferType = this.labels.cash;
      }
      else if (this.transferType === transferTypes.POSITIONS_CASH) {
        this.formTransferType = this.labels.positionsCash;
      }
      else {
        this.formTransferType = '';
      }
    });

    this.store.select(selectIsStandingAuthViewPage).pipe(takeUntil(this.destroy$)).subscribe(value => this.isStandingAuthViewPage = value);
    this.store.select(selectIsTransactionsViewPage).pipe(takeUntil(this.destroy$)).subscribe(value => this.isTransactionViewPage = value);

    this.store.select(selectPositionLotTableData).pipe(takeUntil(this.destroy$), withLatestFrom(this.store.select(selectCostBasisMethod))).subscribe(([info, method]) => {
      if (info && info.length) {
        this.costBasisDefault = 'Account default: ' + this.getCBFormValue(method);
        this.costBasis = info[0]['nodeCostBasis'];
        this.costBasis = this.getCBFormValue(this.costBasis);
        if (method === info[0]['nodeCostBasis']) {
          this.costBasis = 'Account default: ' + this.costBasis;
        }
        if (info[0]['nodeCostBasis'] === '') {
          this.costBasis = 'Account default: ' + this.getCBFormValue(method);
        }
      }
    })

 combineLatest([
    this.store.select(selectStagedTransactionForm),
      this.store.select(selectInternalTransferInfo)
  ]).pipe(takeUntil(this.destroy$)).subscribe(([form, itInfo]) => {
      if (form?.transactionType && isInternalTransferForm(form)) {
        if (form.transactionType === transactionTypes.internalTransfer) {
          let extraPrompts = form.extraPrompts;
          this.transactionTypeLabel = this.getTransactionTypeLabel(extraPrompts);
          this.isBundledStandingAuthTransaction = extraPrompts.useBundledStandingAuth === 'yes';
          this.instructionId = extraPrompts.standingAuthId ?? '';
          let transactionDetails = form.transactionDetails;
          this.isRecurring = itInfo.recurringFields?.isRecurringTransaction;
          this.useStandingAuth = this.getStandingAuthValue(extraPrompts),
          this.frequency = this.getFrequency(extraPrompts);
          this.amountType = amountTypeDict[transactionDetails.amountType];
          this.secondProcessDate = transactionDetails.recurringFieldsFormGroup?.recurringFrequency === 'SEMIMTH' ? transactionDetails.recurringFieldsFormGroup?.secondProcessDate : '';
          this.endDate = transactionDetails.recurringFieldsFormGroup?.endDate ?? '';
          this.frequencyDescription = this.isRecurring ? itInfo.recurringFields.frequencyList.find(frequency => frequency.code === transactionDetails.recurringFieldsFormGroup.recurringFrequency)!.description : '';
          this.payIncome = this.isRecurring && transactionDetails.recurringFieldsFormGroup?.payIncome?.trim() ? this.titleCasePipe.transform(itInfo.recurringFields.payIncomeMap.find(payIncome => payIncome.code === transactionDetails.recurringFieldsFormGroup.payIncome)!.description) : '';
          this.amount = transactionDetails.amount;
          this.amountType = transactionDetails.amountType;
          this.fedTaxPercent = this.isIraTransaction ? itInfo.iraFields.fedTaxPercent : '';
          this.stateTaxPercent = this.isIraTransaction ? itInfo.iraFields.stateTaxPercent : '';
          this.trustIncomePercent = this.classifications.isPtrs ? this.percentFormatPipe.transform(transactionDetails!.trustIncomePercent!) : '';
          this.trustPrincipalPercent = this.classifications.isPtrs ? this.percentFormatPipe.transform(transactionDetails!.trustPrincipalPercent!) : '';
          this.trustTaxCode = this.classifications.isPtrs ? transactionDetails!.trustTaxCode! : '';
          this.trustPaidFor = this.classifications.isPtrs ? transactionDetails!.trustPaidFor! : '';
          this.trustComment = form.transactionDetails.trustComment ?? '';
          this.trustTaxCategory = form.transactionDetails.trustTaxCategory ?? '';
          this.trustIncomeToPercent = form.transactionDetails.trustIncomeToPercent ?? '';
          this.trustPrincipalToPercent = form.transactionDetails.trustPrincipalToPercent ?? '';
          this.depositTaxCode = form.transactionDetails.trustDepositCode ?? '';
          this.nextProcessDate = itInfo.recurringFields.nextProcessDate ?? '';
          this.hasPositions = itInfo.positionsInfo.hasSelected !== undefined ? itInfo.positionsInfo.hasSelected : false
          this.isPositionsOnly = (this.hasPositions && (itInfo.netCashAmount === "$0.00")) ? true : false;
        }
      }
    });

    if (this.costBasisDefault == "" && this.costBasis == "") {
      this.store.select(selectInternalTransferInfo).pipe(takeUntil(this.destroy$)).subscribe(itInfo => {
        if (this.hasPositions && itInfo.positionsInfo.defaultCostBasisMethod !== undefined && itInfo.positionsInfo.costBasisMethodSelected !== undefined) {
          this.costBasisDefault = 'Account default: ' + this.getCBFormValue(itInfo.positionsInfo.defaultCostBasisMethod);
          this.costBasis = this.getCBFormValue(itInfo.positionsInfo.costBasisMethodSelected);
        }
      });
    }

    if ((this.costBasis !== "" && this.costBasis !== undefined) && (this.costBasisDefault !== "" && this.costBasisDefault !== undefined)) {
      this.showCostBasis = true;
    }

    this.store.select(selectIsPendingItSloaSetup).pipe(takeUntil(this.destroy$)).subscribe(isPendingSloaSetup => {
      this.isPendingSloaSetup = isPendingSloaSetup;
    })

    this.store.select(selectInfo).pipe(takeUntil(this.destroy$)).subscribe(info => {
      this.accountInfo = info;
    })

    combineLatest([this.store.select(selectItStandingAuth), this.store.select(selectToAccountInfo)]).pipe(takeUntil(this.destroy$)).subscribe(([instructions, toAccountInfo]) => {
      let standingAuth = instructions.find(instruction => this.instructionId == 'i-' + instruction.cashieringRqstId + '-' + instruction.cashieringRqstSecondId);

      this.toAccountInfo = toAccountInfo;
      this.standingAuthDetails = [toAccountInfo.accountNumber + ' - ' + toAccountInfo.registrationType];

      this.showToAccountAvailableCash = toAccountInfo.availableCashMmf !== '' && toAccountInfo.availableCashMmf !== null;
      if (toAccountInfo?.accountNumber) {
        this.isSameFirm = toAccountInfo.accountRegistration.length > 0;
      }
      this.store.select(selectNraIndicator).pipe(takeUntil(this.destroy$)).subscribe(nraIndicator => {
        this.nraIndicator = nraIndicator ?? false;
      });

      this.store.select(selectItStwProcessCode).subscribe(value => {
        this.stwProcessCode = value;
      });

    });

    this.store.select(selectStateCode).pipe(takeUntil(this.destroy$)).subscribe((stateCode) => {
      if (stateCode && !this.nraIndicator) {
        this.stateTaxLabel = `${this.labels.stateTax} (${stateCode})`;
      }
    });
  }

  isPositionsTransaction(transferType: string): boolean {
    return transferType === transferTypes.POSITIONS || transferType === transferTypes.POSITIONS_CASH;
  }

  updateGridReady(ready: boolean) {
    this.store.dispatch(gridReady({ gridReady: ready, tab: 'All' }));
  }
  public mapPositions(positionsLotDetails: any[]): any[] {
    this.totalSharesCount = 0;
    this.displaytotalShared = 0;
    let totalMarketValue: number = 0;
    let output = positionsLotDetails.filter(position => position.isSelected).map(position => {
      this.displaytotalShared = this.displaytotalShared + Number(position.selectedQuantity);
      totalMarketValue += position.selectedMarketValue;
      this.totalSharesCount += 1;
      return {
        "Symbol": position.symbol,
        "Name": this.convertToCamelCase(position.fullName),
        "Current price/share": this.currencyPipe.transform(position.price),
        "Cost basis": this.currencyPipe.transform(position.costBasis),
        "Shares to move": Number(position.selectedQuantity).toLocaleString("en-US"),
        "Est mkt val": this.currencyPipe.transform(position.selectedMarketValue)
      }
    });
    this.displaySelectedValue = this.currencyPipe.transform(totalMarketValue);
    this.displaytotalShared = Number(parseFloat(parseFloat(this.displaytotalShared).toFixed(5))).toLocaleString("en-us");
    return output;
  };

  public onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.api;

  }

  getRowHeight = (
    params: RowHeightParams
  ) => 29;

  convertToCamelCase(symbolName: string) {
    return symbolName.split(' ').map(function (word, index) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
  }

  onpositionTitleClicked(){
    this.displayPositionsSection = !this.displayPositionsSection;
  }

  currencyComparator(valueA: string | number, valueB: string | number) {
    if (typeof valueA === 'string' && typeof valueB === 'string') {
      valueA = +valueA.replace(/[^\-\w\s^.]/gi, '');
      valueB = +(valueB.replace(/[^\-\w\s^.]/gi, ''));
    }
    return +valueA - +valueB;
  }

  exportTable(): void {
    this.store.select(selectSubAccountId).pipe(takeUntil(this.destroy$)).subscribe(subAccountId => { this.subAccountId = subAccountId })
    this.gridApi?.exportDataAsExcel(this.getParams());
  }

  getParams() {
    const exportDate = DateTime.now().toFormat('MM-dd-yyyy') + '_' + DateTime.now().toLocaleString(DateTime.TIME_WITH_SHORT_OFFSET);
    return {
      author: '',
      fileName: 'InternalTransferPositionDetails_' + this.subAccountId + '_' + exportDate,
      sheetName: 'Sheet1',
      columnKeys: this.gridColumnApi?.getAllDisplayedColumns(),
    }
  }
  getCBFormValue(costBasis: string) {
    if (costBasis === '') {
      return costBasis;
    }
    return positionConstants.costBasisMap.get(costBasis);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  onEditClicked(): void {
    this.store.dispatch(ReviewPageActions.editClicked());
  }

  getTaxAmount(tax: string): string {
    return tax?.split(' ')[0];
  }

  getFrequency(extraPrompts: ItExtraPrompts): string {
    // this indicates non-bundled flow
    if (extraPrompts.frequency) {
      return frequencyDict[extraPrompts.frequency!];
    }

    if (extraPrompts.useStandingAuth === 'bundled') {
      if (extraPrompts.useBundledStandingAuth === 'no') return frequencyDict['onetime'];
      if (extraPrompts.useBundledStandingAuth === 'recurring') return frequencyDict['recurring'];
    }
    return '';
  }

  getTransactionTypeLabel(extraPrompts: ItExtraPrompts): string {
    let initialTransactionTypeLabel = this.isStandingAuthViewPage ? 'Internal cash transfers (journal)' : transactionTypesDict['internal-transfer'];
    if (extraPrompts.useStandingAuth === 'bundled'){
      return `${initialTransactionTypeLabel} - bundled`;
    }
    return initialTransactionTypeLabel;
  }

  get pageHeader(): string {
    return this.isStandingAuthViewPage ? 'Standing authorization details' : 'Transaction details';
  }

  get displayTrustComment() {
    return (this.classifications.isPtrs || this.isToAccountTrust) && this.trustComment;
  }

  get displayToTrustFields() {
    return this.isToAccountTrust && (this.depositTaxCode || this.isStandingAuthViewPage);
  }

  get amountLabel(): string {
    if (this.classifications.isPtrs || this.isToAccountTrust) {
      if (this.transferType === transferTypes.POSITIONS_CASH) {
        return this.labels.trustCashAmount;
      }
      return this.labels.trustAmount;
    } else {
      if (this.transferType === transferTypes.POSITIONS_CASH) {
        return this.labels.cash;
      }
      return this.labels.amount;
    }
  }

  get isViewPage(): boolean {
    return this.currentPage === pageInContext.view || this.currentPage === pageInContext.viewMsv;
  }

  getStandingAuthValue(extraPrompts: ItExtraPrompts): YesNo | '' {
    if (extraPrompts.useStandingAuth === 'bundled'){
      if (extraPrompts.useBundledStandingAuth === 'yes') return yesNo.yes;
      if (extraPrompts.useBundledStandingAuth === 'no' || extraPrompts.useBundledStandingAuth === 'recurring') return yesNo.no;
      return '';
    }
    return extraPrompts.useStandingAuth;
  }

  isNotEmptyOrNull(param: any) {
    const params = param?.trim();
    if (params === null || params === undefined || params === 'undefined%' || params === '') {
      return false;
    }
    return true;
  }

  formatContribType(contribType: string){
    return contribType.split(' ').map(word => word.charAt(0) + word.slice(1).toLowerCase()).join('-');
  }
}
